var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed max-w-container w-48 sm:w-64 mx-auto"},[_c('img',{staticClass:"w-full cursor-pointer",attrs:{"src":require('@/assets/images/support-button.png'),"alt":"support button"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }